import { makeStyles, Theme } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

interface Prop {
  width: number;
  height: number;
}
export const styles = makeStyles<Theme, Prop>(() => ({
  main: {
    '@media (min-aspect-ratio: 16/9)': {
      width: ({ width }) => `${width}vw`,
      height: ({ height }) => `${height}vh`,
    },
    '@media (max-aspect-ratio: 4/3)': {
      height: '72.91vh',
      width: '79.29vw',
    },
    margin: 'auto',
    marginTop: '11.02vh',
    backgroundColor: themeColor.lightBackground,
    outline: 0,
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: '1.2px',
    position: 'relative',
  },

  innerTitle: {
    backgroundColor: themeColor.white,
    height: '5.73vh',
    justifyContent: 'space-between',
    boxShadow: `0px 1px 2px ${themeColor.borderGray}`,
  },
  icon: {
    height: 'auto',
    paddingTop: '1vh',
    paddingBottom: '1vh',
    width: '10%',
    alignContent: 'center',
    justifyContent: 'flex-end',
  },
  adjustIcon: {
    transformOrigin: 'right',
  },
  contentTitle: {
    width: '90%',
    fontSize: rem(3.125),
    fontWeight: 500,
    lineHeight: 'normal',
    color: themeColor.defaultTextColor,
    paddingLeft: '20px',
    justifyContent: 'center',
  },
  inner: {
    marginTop: '3vh',
    marginBottom: '3vh',
    maxWidth: '66.33%',
  },
  bigInner: {
    flrxGrow: '1',
    marginBottom: '3vh',
  },
  innerKeypad: {
    display: 'flex',
    maxWidth: '30%',
    marginTop: '2vh',
    marginRight: '2vw',
    justifyContent: 'center',
    marginBottom: '2.6vh',
    alignSelf: 'flex-end',
  },
  bigInnerKeypad: {
    display: 'flex',
    maxWidth: '40%',
    marginTop: '2vh',
    marginRight: '2vw',
    justifyContent: 'flex-end',
    marginBottom: '2.6vh',
    alignSelf: 'flex-end',
  },
  innerKeypadInverse: {
    display: 'flex',
    maxWidth: '30%',
    marginTop: '2vh',
    marginLeft: '2vw',
    justifyContent: 'center',
    marginBottom: '2.6vh',
    alignSelf: 'flex-end',
  },
  bigInnerKeypadInverse: {
    display: 'flex',
    maxWidth: '40%',
    marginTop: '2vh',
    marginLeft: '2vw',
    justifyContent: 'flex-end',
    marginBottom: '2.6vh',
    alignSelf: 'flex-end',
  },
  cancelButtonContainer: {
    alignSelf: 'flex-start',
    display: 'flex',
    position: 'absolute',
    bottom: '0',
    marginBottom: '2.6vh',
    marginLeft: '1vw',
    width: '100%',
    maxWidth: '66.33%',
  },
  cancelButtonContainerInverse: {
    alignSelf: 'flex-end',
    display: 'flex',
    flexDirection: 'row-reverse',
    position: 'absolute',
    bottom: '0',
    marginBottom: '2.6vh',
    paddingLeft: '1vw',
    width: '100%',
    paddingRight: '1vw',
    maxWidth: '66.33%',
  },
  modalContent: {
    flexDirection: 'row',
  },
  bigModalContent: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
  modalContentInverse: {
    flexDirection: 'row-reverse',
  },
  bigModalContentInverse: {
    flexDirection: 'row-reverse',
    flexWrap: 'nowrap',
  },
}));
